import global from './global.js';
import popover from './popover';
import button from './button';
import dialog from './dialog';
import select from './select';
import inputotp from './inputotp';
import inputtext from './inputtext';
import datatable from './datatable';
import accordion from './accordion';
import accordioncontent from './accordioncontent';
import accordionheader from './accordionheader';
import accordionpanel from './accordionpanel';
import fileupload from './fileupload';
import toggleswitch from './toggleswitch';
import paginator from './paginator';
import tabs from './tabs';
import tab from './tab';
import tablist from './tablist';
import galleria from './galleria';
import drawer from './drawer';
import selectbutton from './selectbutton';
import togglebutton from './togglebutton';
import breadcrumb from './breadcrumb';

export default {
    global,
    button,
    popover,
    dialog,
    select,
    inputotp,
    inputtext,
    datatable,
    accordion,
    accordioncontent,
    accordionheader,
    accordionpanel,
    fileupload,
    toggleswitch,
    paginator,
    tabs,
    tab,
    tablist,
    galleria,
    drawer,
    selectbutton,
    togglebutton,
    breadcrumb,
};
